const footerLinks = {
  '센터 소개': ['사명 및 가치', '연혁', '오시는 길', '채용 안내'],
  '지원 서비스': ['상담 신청', '교육 프로그램', '커뮤니티', '자료실'],
  '소식': ['뉴스레터', '공지사항', '언론 보도', '활동 갤러리'],
  '참여': ['후원하기', '자원봉사', '제휴 문의', '캠페인'],
};

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-amber-950 text-amber-100">
      <div className="max-w-7xl mx-auto px-8 pt-16 pb-8">
        <div className="grid lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-amber-600 rounded-lg">
                <i className="ri-heart-2-fill text-white text-base"></i>
              </div>
              <span className="font-bold text-2xl text-white">대한효복지센터</span>
            </div>
            <p className="text-amber-300/70 text-sm leading-relaxed mb-6">
              활동지원사와 장애인이 함께 성장하는<br />
              따뜻한 복지 생태계를 만들어 나갑니다.
            </p>
            <div className="space-y-2 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-amber-500 text-xs"></i>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=인천시+부평구+원적로+290+산곡메디칼+5층"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-amber-300/70 text-sm hover:text-amber-300 transition-colors cursor-pointer"
                >
                  인천시 부평구 원적로 290 산곡메디칼 5층, 대한효복지센터
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-amber-500 text-xs"></i>
                </div>
                <span className="text-amber-300/70 text-sm">032-511-0012</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-amber-500 text-xs"></i>
                </div>
                <span className="text-amber-300/70 text-sm">misoo3323@naver.com</span>
              </div>
            </div>
            <div className="flex gap-3">
              {[
                { icon: 'ri-kakao-talk-fill', label: '카카오' },
                { icon: 'ri-instagram-line', label: '인스타그램' },
                { icon: 'ri-youtube-line', label: '유튜브' },
                { icon: 'ri-facebook-circle-line', label: '페이스북' },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center bg-amber-800/50 hover:bg-amber-700 rounded-lg transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-amber-300 text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h4 className="font-bold text-white text-sm mb-4">{section}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-amber-300/60 text-sm hover:text-amber-300 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 border-t border-amber-800/50">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-amber-300/50 text-sm">
              © 2026 대한효복지센터. All rights reserved. 사업자등록번호: 122-82-74832
            </p>
            <div className="flex gap-6">
              {['개인정보처리방침', '이용약관', '접근성 안내'].map((item) => (
                <a
                  key={item}
                  href="#"
                  rel="nofollow"
                  className="text-amber-300/50 text-sm hover:text-amber-300 transition-colors cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
          <div className="mt-3 text-center">
            <p className="text-amber-300/30 text-xs">
              이 웹사이트는 웹 접근성을 준수하여 제작되었습니다. 문의: 032-511-0012
            </p>
          </div>
        </div>
      </div>

      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
        <button
          onClick={() => handleNav('#counseling')}
          className="w-12 h-12 flex items-center justify-center bg-amber-600 hover:bg-amber-700 text-white rounded-full shadow-lg transition-all cursor-pointer"
          title="상담 신청"
        >
          <i className="ri-chat-2-line text-lg"></i>
        </button>
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="w-12 h-12 flex items-center justify-center bg-stone-700 hover:bg-stone-800 text-white rounded-full shadow-lg transition-all cursor-pointer"
          title="맨 위로"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      </div>
    </footer>
  );
}
